
import {defineComponent, PropType} from "vue"
import {ExcursionFilter, ExcursionFilterValue} from "@/services/filters/types";
import {IFilter} from "@/services/filters/types/IFilter";
import SelectFilter from "@/services/filters/types/SelectFilter";

export default defineComponent({
  props: {
    filter: {
      required: true,
      type: Object as PropType<SelectFilter>
    }
  },
  methods: {
    openPanel(){
      this.opened = !this.opened;
      if(this.opened) {
        const block = this.$refs.content as HTMLElement
        this.height = block.getBoundingClientRect().height;
      } else {
        this.height = 0;
      }
    },
    checkOption(filter: SelectFilter,value: ExcursionFilterValue){
      console.log(value)
      filter.toggleOption(value)
    }
  },
  data(){
    return {
      opened: false,
      height: 0,
    }
  }
})
